import { gql } from '@apollo/client';

export const FETCH_REASONS = gql`
	query crewMemberAbsenceReasons {
		crewMemberAbsenceReasons {
			id
			name
			code
			isPayable
		}
	}
`;
